export const LeaveRequestEnum = Object.freeze({
  Pending: 0,
  Approved: 1,
  Rejected: 2,
  Cancelled: 3,
});

export const LeaveRequestEnumLabel = Object.freeze({
  [LeaveRequestEnum.Pending]: "Pending",
  [LeaveRequestEnum.Approved]: "Approved",
  [LeaveRequestEnum.Rejected]: "Rejected",
  [LeaveRequestEnum.Cancelled]: "Cancelled",
});
